import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type ProductActions = {
  canUpdateAccomodation: boolean
  canUpdateType: boolean
}

export function getProductActions(id: number) {
  return restApiClient
    .url(constructApiUrl(API.products.getActions.url, { id }))
    .get<ProductActions>()
}
